import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Helpers from "../base/Helpers";
import Flickity from 'flickity';
const serialize = require('form-serialize');
document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('modal:shipping:open', function(e){
        let triggerPopup = e.detail.trigger
        let collectionModal = document.querySelector(`[data-section-type="shipping-modal-section--${triggerPopup}"]`)
        let productItem = document.querySelectorAll(`.shipping-popup--item-${triggerPopup}`)
        let productList = document.querySelector(`.product-list--shipping-modal-${triggerPopup}`)
        let shippingModalFormGifts = document.querySelector(`#popupShippingForm-${triggerPopup}`);
        let inputChecksGifts = shippingModalFormGifts.querySelectorAll(`.product-input-${triggerPopup}`);

        function colorSwatchGiftSection(){
            if (!!shippingModalFormGifts) {
                shippingModalFormGifts.querySelectorAll('.product-item__swatch-list .color-swatch__radio').forEach(function (swatch) {
                    swatch.addEventListener('change',e => {
                        var shippingProductItemGifts = e.target.closest(`.shipping-popup--item-${triggerPopup}`)
                        var variantShippingUrlGifts = e.target.getAttribute('data-variant-url');
            
                        shippingProductItemGifts.querySelector('.product-item__image-wrapper').setAttribute('href', variantShippingUrlGifts);
            
            
                        var originalImage = shippingProductItemGifts.querySelector('.product-item__primary-image');
            
                        if (e.target.hasAttribute('data-image-url') && e.target.getAttribute('data-media-id') !== originalImage.getAttribute('data-media-id')) {
                            var newImage = document.createElement('img');
                            newImage.className = 'product-item__primary-image lazyload image--fade-in';
                            newImage.setAttribute('data-media-id', e.target.getAttribute('data-media-id'));
                            newImage.setAttribute('data-src', e.target.getAttribute('data-image-url'));
                            newImage.setAttribute('data-widths', e.target.getAttribute('data-image-widths'));
                            newImage.setAttribute('data-sizes', 'auto'); // Replace the original node
                            originalImage.parentNode.style.paddingBottom = "".concat(100.0 / newImage.getAttribute('data-image-aspect-ratio'), "%");
                            originalImage.parentNode.replaceChild(newImage, originalImage);
                        
                        }

                        var selectedVariantIdGifts = e.target.getAttribute('data-variant-id')
                        var formShippingGifts = e.target.closest(`.shipping-popup--item-${triggerPopup}`)
                        var productIdGifts = e.target.getAttribute('data-original-product')
                        var formInputGifts = formShippingGifts.querySelector(`#product-${triggerPopup}-${productIdGifts}`)
                        if(!!formInputGifts) {
                            formInputGifts.value = selectedVariantIdGifts
                            document.dispatchEvent(new CustomEvent('value:changed'));
                        }
                    })
                })
            }
        
        }

        function initializeForm(){

            document.addEventListener('qty:change', e =>{
                const parenElementGifts = e.target.activeElement.closest(`.shipping-popup--item-${triggerPopup}`)
                const inputElementGifts = parenElementGifts.querySelector('input[type=checkbox]')
                if (Number(e.target.activeElement.value) === 0 ) {
                    inputElementGifts.checked = false
                    parenElementGifts.classList.remove('shipping-product--selected')
                }else {
                    inputElementGifts.checked = true
                    parenElementGifts.classList.add('shipping-product--selected')
                }
                calculateGiftTreshold()
            })

            if (!!inputChecksGifts) {
                inputChecksGifts.forEach(function(check){
                    check.addEventListener('click', function(e){
                        if (e.target.checked) {
                            e.target.parentNode.classList.add('shipping-product--selected')
                        }else {
                            e.target.parentNode.classList.remove('shipping-product--selected')
                        }
                        calculateGiftTreshold()
                    })
                })
            }

        
            let allProductsIdGifts = []
            inputChecksGifts.forEach(e =>{
                allProductsIdGifts.push(e.value)
            })

            document.addEventListener('value:changed', function(){
                allProductsIdGifts = []
                inputChecksGifts.forEach(e =>{
                    allProductsIdGifts.push(e.value)
                })
            })
            // Handle the submit function
            if (!!shippingModalFormGifts) {
                shippingModalFormGifts.addEventListener("submit", function(e){
                    e.preventDefault();
                    const serializedFormDataGifts = serialize(this, { hash: true })
                    let productListsGifts = []
                    if (!!allProductsIdGifts) {
                        allProductsIdGifts.forEach((id, indx)=>{
                            if (!!serializedFormDataGifts.id) {
                                if (serializedFormDataGifts.id.includes(id)) {
                                    productListsGifts.push({
                                        id: id,
                                        quantity: serializedFormDataGifts.quantity[indx]
                                    })
                                }
                            }
                        })
                    }
                    handleFormSubmit(productListsGifts)
                })
            }
        
        }
        
        function handleFormSubmit(formData) {
            let items = []
            formData.forEach((data, index) => {
                items[index] = {
                id: data.id,
                quantity: data.quantity
                }
            });
            addProductsToCart(items)
        }

        function addProductsToCart(items) {
            let formData = {
                items: items
            };
            // Add items via helpers file
            Helpers.addCartItems(formData).then((response) => {
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
                document.dispatchEvent(new CustomEvent('cart:rerendered'));
                if (response.status === 200) {
                    window.location.reload();
                }
            });
        }

        // Sort products by price low/high or high/tow depending on shipping costs
        function sortNodesByOrder(products) {           
            let sortedArrayGifts = [];
            if (!!products) {
                products.forEach((el) => {
                    sortedArrayGifts.push(el);
                    const order = el.order;
                    if (!!order) {
                        if (Number(order) < 2000) {
                            sortedArrayGifts.sort(function(a, b) {
                                return a.productPrice - b.productPrice
                            }) 
                        }else {
                            sortedArrayGifts.sort(function(a, b) {
                                return  b.productPrice - a.productPrice
                            }) 
                        } 
                    }
                });
            }
            return sortedArrayGifts;
        }

        // Get the products that should be sorted and create array of them
        function getProductsWithOrder() {
            let formattedListGifts = [];
            if (!!productItem) {
                productItem.forEach(p => {
                    if (!!p.dataset.order) {
                        formattedListGifts.push({
                            order: p.dataset.order,
                            productNode: p,
                            productPrice: p.dataset.price
                        });
                    }
                });
            }
            return formattedListGifts;
        }

        // Replace the wrapper with unsorted products with the new one
        function replaceProductNodes(oldProductsList, sortedProductsList) {
            if (!!sortedProductsList) {
                const wrapperEl = document.createElement('div')
                wrapperEl.classList = `product-list product-list--vertical product-list--scrollable product-list--shipping-modal-${triggerPopup}`
                sortedProductsList.forEach((sortedProduct) =>{
                    wrapperEl.appendChild(sortedProduct.productNode)
                    oldProductsList.replaceWith(wrapperEl);
                });
                document.dispatchEvent(new CustomEvent('modal:opened'))
            }
        }

        function calculateGiftTreshold(){
            if (!!!(productItem)) {
                return;
            }
            let totalGitstThreshold = 0
            let totalGitstThresholdPrice = 0
            let missingThresholdTemp = 0

            productItem.forEach(item =>{
                const productWrapper = item
                const shippingSpanPriceGift = collectionModal.querySelector('.free-gift--missing-amount')
                const shippingSpanFreeGift = collectionModal.querySelector('.free-gift-text--free')
                const shippingSpanGift = collectionModal.querySelector('.free-gift-text__missing-amount')
                const checkboxInputGift = item.querySelector('input[type=checkbox]')
                missingThresholdTemp = Number(item.getAttribute('data-missing-gift'))

               
                
                if (checkboxInputGift.checked) {
                    const quantitySelector = productWrapper.querySelector('.quantity-selector')
                    let productPrice = Number(quantitySelector.getAttribute('data-price'))
                    let productQuantity = Number(quantitySelector.value)

                    totalGitstThresholdPrice = productPrice * productQuantity
                    totalGitstThreshold = totalGitstThreshold + totalGitstThresholdPrice
                }
                missingThresholdTemp = missingThresholdTemp - totalGitstThreshold

                if(missingThresholdTemp <= 0){
                    shippingSpanGift.classList.add('hidden')
                    shippingSpanFreeGift.classList.remove('hidden')
                }else {
                    shippingSpanGift.classList.remove('hidden')
                    shippingSpanFreeGift.classList.add('hidden')
                    shippingSpanPriceGift.innerHTML = ( missingThresholdTemp / 100).toFixed(2).replace(/\./, ',')+ '€'
                }
            })

        }

    
        colorSwatchGiftSection()
        const sortedProductsGiftsTrigger = getProductsWithOrder();
        if(!!sortedProductsGiftsTrigger && sortedProductsGiftsTrigger.length != 0) {
            const sortedNodes = sortNodesByOrder(sortedProductsGiftsTrigger);
            replaceProductNodes(productList, sortedNodes);
        }
        
        document.addEventListener("modal:opened", function () {
            
            let flickityElementProduct = collectionModal.querySelector(`.product-list--shipping-modal-${triggerPopup}`)
            if (!!flickityElementProduct) {
                var fkty = new Flickity(flickityElementProduct, {
                    watchCSS: true,
                    pageDots: false,
                    prevNextButtons: true,
                    contain: true,
                    resize: false,
                    groupCells: true,
                    freeScroll: true,
                    wrapAround: false,
                    cellAlign: 'left',
                    draggable: !window.matchMedia('(-moz-touch-enabled: 0), (hover: hover)').matches
                })
                
            }
         
            initializeForm()
        })
       
        document.addEventListener('cart:rerendered', function(){
            colorSwatchGiftSection()
            const rerenderedNodesGiftsTrigger = getProductsWithOrder();
            if(!!rerenderedNodesGiftsTrigger) {
                const sortedNodesRerendered = sortNodesByOrder(rerenderedNodesGiftsTrigger);
                replaceProductNodes(productList, sortedNodesRerendered);
            }
        });
    })
});   